<template>
    <li
        class="gallery-thumb-item flex-shrink-0 transition-all transision-200 relative cursor-pointer"
        :class="{'border-4 border-gold-500': isActive}"
        @click="clicked"
    >
        <img
            class="cursor-pointer"
            :src="thumbnailUrl"
            :alt="alt"
            width="100"
            height="69">
    </li>
</template>

<script>
export default {
  name: 'ProductGalleryThumbnail',
  components: {
  },
  props: {
    isActive: {
      type: Boolean,
      required: true,
    },
    alt: {
      type: String,
      required: false,
    },
    thumbnailUrl: {
      type: String,
      required: true,
    },
  },
  methods: {
    clicked() {
      this.$emit('click');
    },
  },
};
</script>

<style scoped>

</style>
